/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CBRRoutePlanUpdateMutation($routePlanId: ID, $routePlanIds: [ID!], $input: [CBRRoutePlanUpdateInput!]!) {
  CBRRoutePlanUpdate(routePlanId: $routePlanId, routePlanIds: $routePlanIds, input: $input) {
    id,
    message
    status
  }
}
`
